import React from "react"

class FilterButton extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    var self = this;
    $(() => {
      $('#filter').multiselect({
        allSelectedText: 'All',

        onChange: () => {
          self.props.onChangeSelectedFilterActions($('#filter').val())
        }
      })

      .multiselect('dataprovider', self.props.filter_actions )
      .multiselect('updateButtonText');
    });
  }

  render() {
    return(
      <div>
        <select  id="filter"  multiple="multiple"></select>
      </div>
    )
  }
}

export default FilterButton